// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { list, patch, put, get } from "./operations.js";
export type {
  EncryptionScopesListOptionalParams,
  EncryptionScopesPatchOptionalParams,
  EncryptionScopesPutOptionalParams,
  EncryptionScopesGetOptionalParams,
} from "./options.js";
